export const environment = {
  production: true,
  baseURL: 'https://api-core.lavalog.com.br/api/'
};
